import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { Accordion, AccordionDetails, AccordionSummary, Grid, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import useDebounce from 'utils/customHook/useDebounce'
import SimpleSelectionTable from 'components/datatable/SimpleSelectionTable'
import { nbPerPageLabelTiny } from 'referencial/constants/ReferencialConstants'

const HydroDataTypes = ({
    parameters = [],
    setParameters = () => {},
    getGlobalParameter = () => {},
    moduleParameters = [],
    setModuleParameters = () => {},
    getGlobalModuleParameter = () => {},
    hydrometryDataTypes = [],
    isGlobal = false,
}) => {
    const parameter = 'HYDROMETER_DATA_TYPE'

    const foundParameter = parameters.find(p => p.parameter === parameter)?.value
    const foundModuleParameter = moduleParameters.find(p => p.parameter === parameter)?.value

    const [hydroDataType, setHydroDataType] = useState(foundParameter ? foundParameter.split(',').map(e => Number(e)) : [])
    const [moduleHydroDataType, setModuleHydroDataType] = useState(foundModuleParameter ? foundModuleParameter.split(',').map(e => Number(e)) : [])

    const onChange = (e) => {
        if (isGlobal) {
            setHydroDataType(e)
        } else {
            setModuleHydroDataType(e)
        }
    }

    const selectedList = isGlobal ? hydroDataType : moduleHydroDataType

    useDebounce(() => {
        setParameters(prev => [
            ...prev.filter(p => p.parameter !== parameter),
            getGlobalParameter(parameter, `${hydroDataType}`),
        ])
    }, 200, [hydroDataType])

    useDebounce(() => {
        setModuleParameters(prev => [
            ...prev.filter(p => p.parameter !== parameter),
            getGlobalModuleParameter(parameter, `${moduleHydroDataType}`),
        ])
    }, 200, [moduleHydroDataType])

    return (
        <Grid size={12} justifyContent='space-between' alignItems='center' columnSpacing={1} spacing={1} paddingX={6}>
            <Accordion>
                <AccordionSummary>
                    {isGlobal ? i18n.dataTypes : i18n.dataTypesVisibleOnThisModule}
                </AccordionSummary>
                <AccordionDetails>
                    <Stack spacing={1}>
                        {!isGlobal && <Typography fontStyle='italic'>{i18n.configurationOfTheApplicationWillNotBeModified}</Typography>}
                        <SimpleSelectionTable
                            onChange={onChange}

                            listData={hydrometryDataTypes}
                            selectedList={selectedList}

                            listHeaders={['id', 'label']}
                            listTitle={i18n.nonSelectedParameters}
                            selectedListTitle={i18n.selectedParameters}

                            nbPerPage={nbPerPageLabelTiny}
                        />
                    </Stack>
                </AccordionDetails>
            </Accordion>
        </Grid>
    )
}

HydroDataTypes.propTypes = {
    parameters: PropTypes.arrayOf(PropTypes.shape({})),
    setParameters: PropTypes.func,
    getGlobalParameter: PropTypes.func,
    moduleParameters: PropTypes.arrayOf(PropTypes.shape({})),
    setModuleParameters: PropTypes.func,
    getGlobalModuleParameter: PropTypes.func,
    hydrometryDataTypes: PropTypes.arrayOf(PropTypes.shape({})),
    isGlobal: PropTypes.bool,
}

export default HydroDataTypes
